import React, {Component} from 'react'
import {inject, observer} from 'mobx-react'
import {Button, Form, Row, Col, Input} from 'antd'
import {PAGE_SIZE_DEFAULT} from '../../../constants/appConstant'
import FormModal from './FormModal'
import UPM from '../../../constants/urlPermissionMappings'
import {PlusOutlined, SearchOutlined} from '@ant-design/icons'
import {withTranslation} from 'react-i18next'
const storage = window.localStorage

@inject('intelligentOutboundCallModelStore', 'intelligentOutboundCallStore', 'marketingSmsManagementStore', 'accountStore')
@observer
class SearchForm extends Component {
  state = {
    addModalVisible: false,
  }
  formRef = React.createRef()
  componentDidMount() {
    const {intelligentOutboundCallModelStore, intelligentOutboundCallStore, marketingSmsManagementStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    intelligentOutboundCallModelStore.onSearchJobAction({
      page: 1, 
      size: PAGE_SIZE_DEFAULT, 
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
      configName: '',
    })
    marketingSmsManagementStore.onGetGroup({
      isPowerUser : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser
    })
    intelligentOutboundCallStore.onExpoAction()
    intelligentOutboundCallStore.onGetCallerList()
    intelligentOutboundCallModelStore.onBindAction({})
  }
  handleSearch = () => {
    const {intelligentOutboundCallModelStore, accountStore} = this.props
    const {accountInfos} = accountStore
    const infos = JSON.parse(storage.getItem('accountInfos'))
    this.formRef.current.validateFields().then(fieldsValue => {
      let params = {
        'configName': fieldsValue.configName,
        'isPowerUser' : accountInfos?.data?.isPowerUser || infos?.data?.isPowerUser,
        'page': 1,
        'size': PAGE_SIZE_DEFAULT
      }
      intelligentOutboundCallModelStore.onSearchJobAction(params)
    }).catch(err => {
    })
  }
  handleCreate = () => {
    this.setState({
      addModalVisible: true
    })
  }
  handleCancel = () => {
    this.setState({
      addModalVisible: false
    })
  }

  render() {
    const {location, t} = this.props
    return (
      <>
        <Form ref={this.formRef} size="middle" className="searchForm" layout="vertical">
          <div className="searchFormTitle">
            <SearchOutlined/> {t(`menu.${UPM.find(item => item.url === location?.pathname)?.pKey}`)}
          </div>
          <Row gutter={[10, 10]}>
            <Col span={6}>
              <Form.Item name="configName" label={t(`outboundCall.modelName`)}
                rules={[{
                  message: `${t(`general.pleaseEnter`)} ${t(`outboundCall.modelName`)} ${t(`general.withoutSpecialChats`)}`,
                  pattern: new RegExp(/^[^&|;\\\s][^&|;\\]*$/)
                }]}
              >
                <Input maxLength={100} placeholder={t(`general.pleaseEnter`)} allowClear/>
              </Form.Item>
            </Col>
            <Col span={18} style={{textAlign: 'right', marginBottom: 10}}>
              <Button onClick={this.handleSearch} className="ant-btn-red">{t(`general.search`)}</Button>
              <Button onClick={this.handleCreate} type="primary" icon={<PlusOutlined/>}>{t(`general.add`)}</Button>
            </Col>
          </Row>
        </Form>
        {this.state.addModalVisible ? <FormModal
          addModalVisible={this.state.addModalVisible}
          handleCancel={this.handleCancel}
        /> : null}
      </>
    )
  }
}

export default withTranslation()(SearchForm)

